/** What the sign-in prompt says under its title: the gate's and a failed load's. */
export const SIGN_IN_DETAIL =
  "Sign in or create an account to see your workspaces, links and notes.";
